var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20V0H20V20H0ZM15.5447 5.76325L16.6161 4.73647V4.51325H12.9018L10.2545 11.1159L7.24555 4.50879H3.34823V4.73647L4.6027 6.24986C4.7277 6.36147 4.7902 6.52218 4.77234 6.68736V12.6249C4.80805 12.8391 4.74109 13.0579 4.5893 13.2141L3.17859 14.924V15.1516H7.18752V14.924L5.7768 13.2141C5.62502 13.0579 5.54912 12.8391 5.58037 12.6249V7.49093L9.09377 15.1516H9.50002L12.5179 7.49093V13.6025C12.5179 13.7633 12.5179 13.7945 12.4107 13.9016L11.3259 14.9552V15.174H16.5938V14.9463L15.5447 13.9195C15.4509 13.8525 15.4063 13.7365 15.4241 13.6204V6.06236C15.4063 5.95075 15.4509 5.83468 15.5447 5.76325Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedium);
export default __webpack_public_path__ + "static/media/icon_medium.b09d5fdb01459fe51ae6791acbe75baf.svg";
export { ForwardRef as ReactComponent };